export default __webpack_public_path__ + "static/media/480_dummy2016-kunsthandwerk01-mobile-de.2c8721f0.png";